import { render } from "./SavedCardMenu.vue?vue&type=template&id=5cfd7f4f"
import script from "./SavedCardMenu.vue?vue&type=script&lang=js"
export * from "./SavedCardMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__